{
  "id": "empty",
  "label": "Tom mall",
  "requiresItems": false,
  "blankAfterTitle": true,
  "planningTitleMirrors": ["memoHeading"],
  "sectionChoice": "suggest",
  "dayGrouping": true,
  "dayHeading": "{DayName} den {dayMonth}",
  "sectionOrder": ["Inrikes", "Utrikes", "Ekonomi", "Kultur och nöje", "Sport"],
  "planning": {
    "titlePattern": "",
    "slugline": ""
  },
  "sources": [
    { "type": "planning" },
    { "type": "article" },
    { "type": "event" }
  ],
  "blocks": [
    {
      "id": "content",
      "label": "Innehåll",
      "grouping": "section",
      "sectionHeadings": [
        { "section": "Inrikes", "heading": "Inrikes" },
        { "section": "Utrikes", "heading": "Utrikes" },
        { "section": "Ekonomi", "heading": "Ekonomi" },
        { "section": "Kultur och nöje", "heading": "Kultur och nöje" },
        { "section": "Sport", "heading": "Sport" }
      ],
      "otherSectionHeading": "Övrigt",
      "topNews": { "heading": "Toppnyheter", "types": ["planning"], "newsvalues": ["5", "6"] },
      "item": {
        "headline": "{headline}",
        "lines": ["{publicDescription}"],
        "assignmentLines": [
          { "types": ["text"], "pattern": "Text: {slugline}: {assignmentTitle}" },
          {
            "types": ["picture", "picture/video", "video"],
            "labels": {
              "picture": "Bild",
              "picture/video": "Bild/video",
              "video": "Video"
            },
            "pattern": "{assignmentLabel}: {assignmentTitle}"
          }
        ]
      },
      "articleItem": {
        "headline": "{headline} – {section}",
        "lines": []
      },
      "eventItem": {
        "headline": "{time} - {headline} {publicDescription}",
        "lines": []
      },
      "eventTitleSections": ["Sport"],
      "eventsHeading": ["Presskonferenser och övrigt"]
    }
  ]
}
